"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _BooleanInput = _interopRequireDefault(require("../../atoms/BooleanInput"));

var _BooleanInputGroup = _interopRequireDefault(require("../../atoms/BooleanInputGroup"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var RadioGroup = function RadioGroup(props) {
  var name = props.name,
      value = props.value,
      defaultValue = props.defaultValue;
  var itemRenderer = (0, _react.useCallback)(function (itemProps) {
    var id = itemProps.id,
        itemValue = itemProps.value;
    var checked = value !== undefined ? itemValue === value : undefined;
    var defaultChecked = value === undefined ? itemValue === value || itemValue === defaultValue : undefined;
    return _react.default.createElement(_BooleanInput.default, _extends({}, itemProps, {
      key: String(id || itemValue),
      type: "radio",
      name: name,
      checked: checked,
      defaultChecked: defaultChecked
    }));
  }, [name, defaultValue, value]);
  return _react.default.createElement(_BooleanInputGroup.default, _extends({}, props, {
    itemRenderer: itemRenderer
  }));
};

var itemShape = _propTypes.default.shape({
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired
});

RadioGroup.propTypes = {
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  disabled: _propTypes.default.bool,
  items: _propTypes.default.arrayOf(itemShape),
  name: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func,
  readOnly: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['normal', 'small']),
  status: _propTypes.default.oneOf(['normal', 'warning']),
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  vertical: _propTypes.default.bool,
  warningMessage: _propTypes.default.string
};
RadioGroup.defaultProps = {
  defaultValue: undefined,
  disabled: false,
  items: [],
  onChange:
  /* istanbul ignore next */
  function onChange() {},
  readOnly: false,
  size: 'normal',
  status: 'normal',
  value: undefined,
  vertical: false,
  warningMessage: undefined
};
var _default = RadioGroup;
exports.default = _default;